<ion-list *ngIf="!db.order_popup" class="listing orderscroll">
  <div class="list_details">
    <ion-grid class="p0">
      <ion-row>
        <ion-col col-6 class="p0">
          <h4>
            <strong>#{{item_value.name}}</strong>
          </h4>
        </ion-col>
        <ion-col col-6 class="p0 textRight font-secondary">
          <h6>
            <strong class="open_sans__font"> {{item_value.total_amount | currency:'&#8377;'}}</strong>
          </h6>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-6 class="p0">
          <p class="f-12">{{item_value.order_date | date: 'MM/dd/yyyy'}} {{item_value.order_time}}</p>
        </ion-col>
        <ion-col col-6 class="p0 textRight">
          <h4 [ngClass]="item_value.shipping_method_name">
            <strong>{{item_value.shipping_method_name}}</strong>
          </h4>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-6 class="p0">
          <p class="go1">
            <ion-icon name="person-outline"></ion-icon> {{item_value.customer_name}} <span
              *ngIf="item_value.phone">({{item_value.phone}})</span>
          </p>
        </ion-col>
        <ion-col col-6 class="p0 textRight">
          <ion-button *ngIf="item_value.status == 'Placed'" class="br10 h25 button-outline-md-danger1">
            {{item_value.status}}
          </ion-button>
          <ion-button *ngIf="item_value.status != 'Placed'" [ngClass]="item_value.status"
            class="br10 h25 button-outline-md-danger1">
            {{item_value.status}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <h6 class="p-l-r-55" style="margin-top: 2px;">
    <strong style="padding-top: 10px !important">Order Items</strong>
  </h6>
  <div class="meals_list bg-box">
    <ion-grid *ngIf="item_value.order_item">
      <div>
        <ion-item *ngFor="let item of item_value.order_item; let index = index">
          <h5 class="id1 s1 go1 menu-name">{{ item.item_name | titlecase }}</h5>
          <br>
          <p [innerHTML]="item.attribute_description" style="white-space: normal">
          </p>
          <p class="f12 ws" style="    white-space: normal;" *ngIf="item.special_instruction">
            <strong>Note:</strong> {{ item.special_instruction }}
          </p>
          <br>
          <h5 class="fw600 id1">
            <span class="open_sans__font qty_value">{{ item.quantity }}</span> x {{ item.price | currency }}
          </h5>
          <h5 *ngIf="item.is_free_item == 0" slot="end" class="open_sans__font id2 font-secondary"
            style="color: #212121;font-weight: 800;">
            {{ item.amount | currency }}
          </h5>
          <h5 *ngIf="item.is_free_item == 1" slot="end" class="id2 font-secondary"
            style="color: #212121;font-weight: 800;">
            FREE
          </h5>
        </ion-item>
      </div>
    </ion-grid>
    <ul>
      <li>
        <ion-grid class="pad-10" style="padding: 5px;">
          <ion-row>
            <ion-col col-6 class="">
              <h6>Sub Total</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong class="open_sans__font">{{ item_value.order_subtotal | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="item_value.tip_amount">
            <ion-col col-6 class="">
              <h6>Tip Amount</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong class="open_sans__font">{{ item_value.tip_amount | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="item_value.shipping_charges">
            <ion-col col-6 class="">
              <h6>Delivery Charges</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong class="open_sans__font">{{ item_value.shipping_charges | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <!-- <ion-row *ngIf="item_value.shipping_charges != item_value.actual_shipping_charges && item_value.shipping_method_name == 'Delivery'">
                    <ion-col col-6 class="">
                      <h6>Delivery Charges </h6>
                    </ion-col>
                    <ion-col col-6 class="textRight ">
                      <h6>
                        <strong> <span class="shipping_amt">{{item_value.actual_shipping_charges | currency}}</span> {{ item_value.shipping_charges | currency }}</strong>
                      </h6>
                    </ion-col>
                  </ion-row> -->
          <ion-row *ngIf="item_value.pickup_charge">
            <ion-col col-6 class="">
              <h6>Pickup Charges</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong class="open_sans__font">{{ item_value.pickup_charge | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col col-6 class="">
              <h6>Tax ({{item_value.tax_rate}}%)</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong class="open_sans__font">{{ item_value.total_tax_amount | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="item_value.discount != 0">
            <ion-col col-6 class="">
              <h6>Discount</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong> - {{ item_value.discount | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col col-6 class="">
              <h6>Round Off</h6>
            </ion-col>
            <ion-col col-6 class="textRight ">
              <h6>
                <strong class="open_sans__font"> - {{ item_value.round_off_value | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
          <ion-row class="id11 bgf5">
            <ion-col col-6 class="">
              <h6>Total</h6>
            </ion-col>
            <ion-col col-6 class="textRight">
              <h6>
                <strong class="open_sans__font">{{ item_value.total_amount | currency }}</strong>
              </h6>
            </ion-col>
          </ion-row>
        </ion-grid>
        <!-- <div style="height: 55px;"></div> -->
      </li>
      <li>
      </li>
    </ul>
  </div>
</ion-list>

  <div *ngIf="db.order_popup && items && !db.ismobile" class="payment__list">
    <div class="d__flex just-s p10 order__dtl_top">
      <div class="d__flex">
        <div class="order-image">
          <img *ngIf="items.order_from == 'Website'" src="assets/icons/orders icon/website-order.svg">
          <img *ngIf="items.order_from == 'POS'" src="assets/icons/orders icon/website-order.svg">
          <img *ngIf="items.order_from == 'Android Mobile App' || items.order_from == 'SE App' " src="assets/icons/orders icon/mobile-order.svg">
          <img *ngIf="items.order_from == 'Swiggy'" src="assets/icons/orders icon/swiggy.svg">
          <img *ngIf="items.order_from == 'Zomato'" src="assets/icons/orders icon/zomato.svg">
        </div>
        <div *ngIf="items" class="cus__date__time__data">
          <div class="order__id">{{items.name}}</div>
          <div class="d__flex">
            <div class="data__time">{{items.order_date | date: 'MM/dd/yyyy'}}</div>
            <div class="d__flex payment__status mr_5"><span class="dot" [class.paid-b]="items.payment_status == 'Paid'" [class.pending]="items.payment_status == 'Pending'" [class.authorized]="items.payment_status == 'Authorized'" [class.partialypaid]="items.payment_status == 'Partially Paid'"></span>
              <p class="m0 p0" [class.paid-c]="items.payment_status == 'Paid'" [class.pend]="items.payment_status == 'Pending'" [class.auth]="items.payment_status == 'Authorized'" [class.partial]="items.payment_status == 'Partially Paid'">{{items.payment_status}}</p>
            </div>
            <!-- <div *ngIf="items.order_time" class="datas__time"> at {{items.order_time}}</div> -->
          </div>
          <div class="Payment_methods d__flex pt10 mt_5">
            <p class="payment_method_name"><ion-icon src="assets/icons/Card-payment.svg"></ion-icon>
              <span *ngFor="let l of items.payment_entries;let j = index">{{l.mode_of_payment}} <span *ngIf="items.payment_entries.length - 1 > j"> / </span></span>
              <span *ngIf="items.payment_entries.length == 0">{{items.payment_method_name}}</span></p>
            <p class="shipping_method_name"><ion-icon src="assets/icons/order-delivery.svg"></ion-icon>{{items.shipping_method_name}}</p>
          </div>
        </div>

      </div>
      <div class="">
        <ion-icon (click)="close()" class="close__icon" slot="end" src="assets/order_icon/close.svg"></ion-icon>

        <ion-buttons class="printMenu__button mouse" (click)="printOrder(items)">
          <ion-button color="" fill="clear">
              <ion-icon src="assets/order_icon/print.svg"></ion-icon>
          </ion-button>
      </ion-buttons>
      </div>
    </div>
    <!-- <div class="paymentType d__flex">
      <ion-buttons class="paymentType__button">
        <ion-button color="" fill="clear">
          <ion-icon src="/assets/icons/Card-03.svg"></ion-icon>
          {{items.payment_method_name}}
        </ion-button>
      </ion-buttons>
      <ion-buttons class="deliverType__button">
        <ion-button color="" fill="clear">
          <ion-icon src="/assets/icons/order-type-delivery-03.svg"></ion-icon>
          {{items.type}}
        </ion-button>
      </ion-buttons>
    </div> -->
    <div class="d__flex h80">
      <div class="productItemList">
        <div class="order-item-title">
          <h6 class="item-image">Items</h6>
          <h6 class="item-detail"></h6>
          <h6 class="item-sku">SKU</h6>
          <h6 class="item-weight">Weight</h6>
          <h6 class="item-qty">Qty</h6>
          <h6 class="item-price">Price</h6>
          <h6 class="item-total">Total Price</h6>
      </div>
      <div class="order-detail-scroll">
        <div *ngFor="let item of items.Items" class="order-items-list">
            <div class="item-image"><img [src]="db.product_img(item.item_image)" alt=""></div>
            <div class="item-detail">
                <h6>{{item.item_name}}</h6>
            </div>
            <div class="item-sku">{{item.item_sku}}</div>
            <div class="item-weight">{{item.weight}}</div>
            <div class="item-qty">
                {{item.quantity}}
            </div>
            <div class="item-price open_sans__font">
                {{item.price|currency:db.currency}}
            </div>
            <div class="item-total txt-right open_sans__font">
                <h6>{{item.t_amount|currency:db.currency}}</h6>
            </div>
        </div>
      </div>
        <div>
          <div class="total__Price d__flex">
          </div>
          <div class="total__Price color d__flex">
            <div class="total">Total Price</div>
            <div class="price open_sans__font">{{items.order_subtotal |currency:db.currency}}</div>
          </div>
          <div class="total__Price color d__flex">
            <div class="total">Shipping Chargers</div>
            <div class="price open_sans__font">{{items.shipping_charges |currency:db.currency}}</div>
          </div>
          <div class="total__Price color d__flex">
            <div class="total">Discount</div>
            <div class="price open_sans__font">{{items.discount |currency:db.currency}}</div>
          </div>
          <div class="total__Price bold d__flex">
            <div class="total">Order Total</div>
            <div class="price open_sans__font">{{items.total_amount |currency:db.currency}}</div>
          </div>
          <div *ngIf="items.advance_amount > 0" class="total__Price color d__flex">
            <div class="total">Advance Amount</div>
            <div class="price open_sans__font">{{items.advance_amount |currency:db.currency}}</div>
          </div>
          <div *ngIf="items.outstanding_amount > 0" class="total__Price bold d__flex">
            <div class="total">Outstanding Amount</div>
            <div class="price open_sans__font">{{items.outstanding_amount |currency:db.currency}}</div>
          </div>
        </div>
      </div>
      <div class="profile-section-info">
        <div class="customer__details border-l">
          <h6>Customer Details</h6>
        </div>
        <!-- [class.border-bottom]="!(item.address || item.city || item.state || item.country || item.zipcode)" -->
        <div class="customer-profile" *ngIf="true">
          <div class="customer-profile" *ngIf="false">
            <img src="assets/icons/default-user-01.svg" alt="">
          </div>
          <div class="customer-name d__flex" *ngIf="items.customer_name[1]">
            <img src="assets/icons/orders icon/customer.svg" alt="">
            <h6>{{items.customer_name}}</h6>
          </div>
          <div class="phone-no" *ngIf="items.phone">
            <img src="assets/icons/orders icon/phone.svg" alt="">
            <h6>{{ items.phone}}</h6>
          </div>
          <div class="mail-id" *ngIf="items.customer_email">
            <img src="assets/icons/orders icon/mail(1).svg" alt="">
            <h6>{{items.customer_email}}</h6>
          </div>
        </div>
        <div class="customer-address" *ngIf="items.address || items.city || items.state || items.country || items.zipcode">
          <div class="customer__details">
            <!-- <img src="/assets/icons/billing.svg"> -->
            <h6>Billing Address</h6>
          </div>
          <div class="biling-address d__flex">
            <img src="assets/icons/orders icon/location.svg">
            <div class="address">   
              <p>{{items.address}}</p>
              <p>{{items.city}}</p>
              <p>{{items.state}}</p>
              <p>{{items.country}}-{{items.zipcode}}</p>
            </div>
          </div>
          <div class="customer__details" *ngIf="items.shipping_shipping_address">
            <!-- <img src="../assets/icons/shipping.svg"> -->
            <h6>shipping Address</h6>
          </div>
          <div class="shiping-address d__flex" *ngIf="items.shipping_shipping_address || items.shipping_city || items.shipping_state || items.shipping_country || items.shipping_zipcode">
            <img src="assets/icons/orders icon/location.svg">
            <div class="address">
              <p>{{items.shipping_shipping_address}}</p>
              <p>{{items.shipping_city}}</p>
              <p>{{items.shipping_state}}</p>
              <p>{{items.shipping_country}}-{{items.shipping_zipcode}}</p>
            </div>
          </div>
        </div>
        <!-- <div class="order-date-section custume-border-bottom custume-border-right custume-border-left" *ngIf="item.order_item != undefined && item.order_item.length != 0">
           && item.order_item[0].delivery_date || item.order_item[0].shipped_date" ->
          <div class="shiping-date">
            <h6>{{ item.order_item != undefined ? item.order_item[0].shipped_date == null?'No Date':item.order_item[0].shipped_date: ''}}</h6>
            <div class="shiping-date-caption">
              <img src="../assets/icons/date.svg" alt="">
              <p>Shipping Date</p>
            </div>
          </div>
          <div class="delevry-date">
            <h6>{{item.order_item != undefined ? item.order_item[0].delivery_date ==null?'No Date':item.order_item[0].delivery_date: ''}}</h6>
            <div class="delivery-date-caption">
              <img src="../assets/icons/date.svg" alt="">
              <p>Delivery date</p>
            </div>
          </div>
        </div> -->
      </div>  
      </div>
  </div>
